import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';

@Component({
  selector: 'vex-measurements',
  templateUrl: './measurements.component.html',
  styleUrls: ['./measurements.component.scss']
})
export class MeasurementsComponent implements OnInit {
  measurements;

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService, private restService: RestService, public guiService: GuiService) { }

  ngOnInit() {
    this.getMeasurements();
  }

  closeModal() {
    this.dialogRef.componentInstance();
  }

  getMeasurements(){
    this.restService.postService('node','/get-user-surveys', {userId: this.guiService.userLogged.user.id}).subscribe((ris)=>{
     this.measurements = ris;
    })
  }
}

